import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles/Container';

export function CollapseBody({
  children,
  isOpen,
  buttonId,
  contentId,
}) {
  return (
    <Container
      id={contentId}
      aria-labelledby={buttonId}
      isOpen={isOpen}
      role="region"
    >
      {children}
    </Container>
  );
}

CollapseBody.defaultProps = {
  buttonId: undefined,
  contentId: undefined,
  isOpen: false,
};

CollapseBody.propTypes = {
  buttonId: PropTypes.string,
  children: PropTypes.node.isRequired,
  contentId: PropTypes.string,
  isOpen: PropTypes.bool,
};
